import AboutUsModule from 'components/about-us/AboutUsModule';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';
import AboutUsSiteInnerContainer from 'components/about-us/AboutUsSiteInnerContainer';
import Monthly10kGiveaway from 'components/dashboard/Monthly10kGiveaway';
import { DaymadeDesignSystemPreviewComponentInfo } from '../';

const ComponentPreview = () => {
  return (
    <AboutUsModule background={'grey'}>
      <AboutUsSiteContainer>
        <div style={{ marginBottom: 24 }}>
          <h3 className="aboutUsTypographyHeaderLarge">
            Monthly 10k Giveaway{' '}
          </h3>
          <p>
            <>
              The Monthly 10k Giveaway component, as used on the dashboard. It
              displays the user's monthly 10k dashboard progress.
            </>
          </p>
        </div>
        <AboutUsSiteInnerContainer background="white" borderRadius withPadding>
          <Monthly10kGiveaway />
        </AboutUsSiteInnerContainer>
      </AboutUsSiteContainer>
    </AboutUsModule>
  );
};

ComponentPreview.daymadeDesignSystemInfo = {
  name: 'Monthly 10k Giveaway',
} as DaymadeDesignSystemPreviewComponentInfo;

export default ComponentPreview;
